import {
  FCard,
  FTypo,
  FGrid,
  FGridItem,
  FItem,
  // FButton,
  FContainer,
} from "ferrum-design-system";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router";
import { BigUtils } from "../../../../../container-components/web3Client/types";
import { RootState } from "../../../../../redux/rootReducer";
import { TruncateWithoutRounding } from "../../../../../utils/global.utils";
import {
  getAPRValueAgainstFarm,
  getHumanReadableFarmName,
} from "../../../common/Helper";
import IconActiveRight from "../../../../../assets/img/right-icon-light-grey.svg";
import IconActiveLeft from "../../../../../assets/img/left-icon-light-grey.svg";
import { ReactComponent as IconNetworkBnb } from "../../../../../assets/img/icon-network-bnb.svg";
import IconNetworkCFrmStr from "../../../../../assets/img/icon-network-cfrm.svg";
import IconNetworkCFrmxStr from "../../../../../assets/img/icon-network-cfrmx.svg";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { getCrucibleFees } from "../../../../../_apis/CABNCrud";
import { TOKEN_TAG } from "../../../../../utils/const.utils";

const CrucibleWithdrawFeeCard = () => {
  let { farm } = useParams<{ farm?: string }>();
  farm = farm === "cFRM-ARBITRUM" ? "cTestFrm" : farm;
  const location: any = useLocation();
  const crucible = useSelector(
    (state: RootState) => state.crucible.selectedCrucible
  );
  const LPStakingDetails = useSelector(
    (state: RootState) => state.crucible.userLpStakingDetails
  );
  const userCrucibleData = useSelector(
    (state: RootState) => state.crucible.userCrucibleDetails
  );
  const { theme, content } = useSelector((state: RootState) => state.config);
  const { aprInformation } = useSelector((state: RootState) => state.crucible);
  const [activeAPRIndex, setActiveAPRIndex] = useState(0);
  const [fees, setFees] = useState<{
    transferFee: number;
    buyFee: number;
    sellFee: number;
    stakeFee: number;
    unwrapFee: number;
    unstakeFee: number;
  }>({
    transferFee: 0,
    buyFee: 0,
    sellFee: 0,
    stakeFee: 0,
    unwrapFee: 0,
    unstakeFee: 0,
  });

  useEffect(() => {
    getCrucibleFee();
  }, []);

  const getCrucibleFee = async () => {
    const farmCabn = {
      cFRM: "626c591625c981612853f3a5",
      cTestFrm: "6519d1a2076c99556a61ef8f",
    };

    const res = await getCrucibleFees(
      farmCabn[farm as keyof typeof farmCabn],
      TOKEN_TAG
    );
    if (res.data?.body?.data?.length) {
      setFees(res.data?.body?.data[0]);
    }
  };

  useEffect(() => {
    getCrucibleFee();
  }, []);

  const aprData =
    Object.keys(aprInformation).length &&
    getAPRValueAgainstFarm(aprInformation, farm);
  let userStake =
    userCrucibleData[farm!] &&
    (userCrucibleData[farm!].stakes || []).find(
      (e: any) =>
        e.address.toLowerCase() ===
        location.state.LPstakingAddress.toLowerCase()
    );

  const GlobalStyles = createGlobalStyle`
  .crucible-farm-dashboard-card-2, .crucible-witdraw-token {
    background-image: url(${theme?.cards?.crucibleTokenCard}) !important;
    .clr_black_light{
      color:${theme?.colors?.backgroundLight}!important;
    }
    .clr_white{
      color:${theme?.colors?.primaryLight}!important;
    }
    .f-btn-primary{
      background:${theme?.colors?.primary}!important;
    }
    .farm-stake{
      color:${theme?.colors?.backgroundLight}!important;
    }
    .unwrap-farm-card{
      background:${theme?.colors?.background}!important;
    }
  }
  `;

  const crucibleWlConfig = theme?.crucibleConfig;

  return (
    <>
      <ThemeProvider theme={theme}>
        <FContainer>
          <div className="crucible-farm-dashboard-card-2 crucible-witdraw-token">
            <div className={"f-mt-1 f-mb-1"}>
              <div className="flex-center-aligned-center">
                <span
                  className="icon-wrap custom-mr-12"
                  style={{ marginLeft: 24 }}
                >
                  <img
                    src={
                      farm?.includes("cFRMx")
                        ? IconNetworkCFrmxStr
                        : IconNetworkCFrmStr
                    }
                    alt="network-cfrm"
                  />
                  {farm?.includes("BNB") && <IconNetworkBnb />}
                </span>
                <p className="custom-font-size-20 font-700 custom-mr-24 clr_white">
                  {crucibleWlConfig?.crucibleFarms[0]
                    ?.sustainableCrucibleFarms ||
                    getHumanReadableFarmName(farm)}
                </p>
                <FTypo
                  size={16}
                  weight={700}
                  color={theme?.colors?.primaryLight}
                >
                  {location?.state?.json[0]?.tokenCard?.header ||
                    content?.farmDashboard?.tokenCard?.header}
                </FTypo>
              </div>
              <FGrid alignX={"center"} className={"f-mt-1 unwrap-farm-card"}>
                <FGridItem
                  alignX={"center"}
                  alignY={"center"}
                  dir={"column"}
                  size={[2, 2, 2]}
                >
                  <p className={"custom-font-size-18 font-600 clr_white "}>
                    {fees.buyFee || 0}%
                  </p>
                  <p className={"custom-font-size-10 clr_black_light"}>
                    Buy Fee
                  </p>
                </FGridItem>
                <FGridItem
                  alignX={"center"}
                  alignY={"center"}
                  dir={"column"}
                  size={[2, 2, 2]}
                >
                  <p className={"custom-font-size-18 font-600 clr_white "}>
                    {fees.sellFee || 0}%
                  </p>
                  <p className={"custom-font-size-10 clr_black_light"}>
                    Sell Fee
                  </p>
                </FGridItem>
                <FGridItem
                  alignX={"center"}
                  alignY={"center"}
                  dir={"column"}
                  size={[2, 2, 2]}
                >
                  <p className={"custom-font-size-18 font-600 clr_white"}>
                    {`${fees.unwrapFee}%` ||
                      `${BigUtils.safeParse(
                        crucible[farm!]?.feeOnWithdrawRate || "0"
                      )
                        .times(100)
                        .toString()}%`}
                  </p>
                  <p className={"custom-font-size-10 clr_black_light"}>
                    Unwrap Fee
                  </p>
                </FGridItem>
                <FGridItem
                  alignX={"center"}
                  alignY={"center"}
                  dir={"column"}
                  size={[2, 2, 2]}
                >
                  <p className={"custom-font-size-18 font-600 clr_white "}>
                    {`${fees.stakeFee}%` ||
                      `${BigUtils.safeParse(
                        crucible[farm!]?.feeOnTransferRate || "0"
                      )
                        .times(100)
                        .toString()}%`}
                  </p>
                  <p className={"custom-font-size-10 clr_black_light"}>
                    Stake Fee
                  </p>
                </FGridItem>
                <FGridItem
                  alignX={"center"}
                  alignY={"center"}
                  dir={"column"}
                  size={[2, 2, 2]}
                >
                  <p className={"custom-font-size-18 font-600 clr_white "}>
                    {`${fees.unstakeFee}%` ||
                      `${BigUtils.safeParse(
                        crucible[farm!]?.feeOnWithdrawRate || "0"
                      )
                        .times(100)
                        .toString()}%`}
                  </p>
                  <p className={"custom-font-size-10 clr_black_light"}>
                    Unstake Fee
                  </p>
                </FGridItem>
                <FGridItem
                  alignX={"center"}
                  alignY={"center"}
                  dir={"column"}
                  size={[2, 2, 2]}
                >
                  <p className={"custom-font-size-18 font-600 clr_white "}>
                    {`${fees.transferFee}%` ||
                      `${BigUtils.safeParse(
                        crucible[farm!]?.feeOnTransferRate || "0"
                      )
                        .times(100)
                        .toString()}%`}
                  </p>
                  <p className={"custom-font-size-10 clr_black_light"}>
                    Transfer Fee
                  </p>
                </FGridItem>
              </FGrid>
              {/* <div className="d-flex justify_start align_center">
                <div className="custom-mr-50">
                  <FTypo
                    size={12}
                    weight={500}
                    color="#6F767E"
                    className={"farm-stake"}
                  >
                    Your Crucible {farm?.includes("BNB") ? "LP" : ""} Farm Stake
                  </FTypo>
                  <div className="justify_center d-flex align_end f-mt-1">
                    <p
                      className={
                        "custom-font-size-20 font-600 clr_white custom-mr-10"
                      }
                    >
                      {farm?.includes("BNB")
                        ? TruncateWithoutRounding(
                            LPStakingDetails[farm!]?.stake || "0",
                            3
                          )
                        : TruncateWithoutRounding(userStake?.stakeOf || "0", 3)}
                    </p>
                    <p className={"custom-font-size-12 font-700 clr_white"}>
                      {farm?.includes("BNB")
                        ? `CAKE-LP ${crucible[farm!]?.symbol}-BNB`
                        : crucible[farm!]?.symbol}
                    </p>
                  </div>
                </div>
                <div>
                  <div className="justify_start d-flex align_center">
                    <img
                      src={IconActiveLeft}
                      onClick={() => {
                        activeAPRIndex !== 0 &&
                          setActiveAPRIndex(activeAPRIndex - 1);
                      }}
                      alt=""
                    />
                    <FTypo
                      size={12}
                      weight={500}
                      color={theme?.colors?.primaryLight}
                      className={"farm-stake"}
                    >
                      {aprData[activeAPRIndex]?.label}
                    </FTypo>
                    <img
                      src={IconActiveRight}
                      onClick={() => {
                        activeAPRIndex < aprData.length - 1 &&
                          setActiveAPRIndex(activeAPRIndex + 1);
                      }}
                      alt=""
                    />
                  </div>
                  <FTypo
                    size={20}
                    weight={700}
                    alignX={"center"}
                    display={"flex"}
                    color={theme?.colors?.primaryLight}
                    className={"f-mt-1"}
                  >
                    {aprData[activeAPRIndex]?.value}
                  </FTypo>
                </div>
              </div> */}
            </div>
          </div>
          {/* <FCard className="card-crucible-token-info">
          <FTypo size={20}>Crucible Token Info</FTypo>
          <FGrid className="info-bar">
            <FGridItem size={[4, 4, 4]}>
              <FItem align={"center"}>
                <FTypo color="#DAB46E" size={20} weight={700} className="f-pb--2">
                  {`${BigUtils.safeParse(crucible[farm!]?.feeOnTransferRate || "0")
                    .times(100)
                    .toString()}%`}
                </FTypo>
                <FTypo size={20}>Stake/Transfer Fee</FTypo>
              </FItem>
            </FGridItem>
            <FGridItem size={[4, 4, 4]}>
              <FItem align={"center"}>
                <FTypo color="#DAB46E" size={20} weight={700} className="f-pb--2">
                  {`${BigUtils.safeParse(crucible[farm!]?.feeOnWithdrawRate || "0")
                    .times(100)
                    .toString()}%`}
                </FTypo>
                <FTypo size={20}>Unwrap Fee</FTypo>
              </FItem>
            </FGridItem>
            <FGridItem size={[4, 4, 4]}>
              <FItem align={"center"}>
                <FTypo color="#DAB46E" size={20} weight={700} className="f-pb--2">
                  {crucible[farm!]?.symbol}
                </FTypo>
                <FTypo size={20}>Crucible Token</FTypo>
              </FItem>
            </FGridItem>
          </FGrid>
          <FCard className={"styled-card align-v your-crucible"}>
            <FGrid>
              <FGridItem size={[6, 6, 6]} dir="column">
                <FTypo className="f-pb--2">Your Crucible {farm?.includes("BNB") ? "LP" : ""} Farm Stake</FTypo>
                <FTypo size={24} weight={600} align={"end"} display="flex" alignY={"end"}>
                  {farm?.includes("BNB") ? TruncateWithoutRounding((LPStakingDetails[farm!]?.stake || "0"), 3) : TruncateWithoutRounding((userStake?.stakeOf || "0"), 3)}

                  <FTypo size={12} weight={300} className={"f-pl--7 f-pb--1"}>
                    {farm?.includes("BNB") ? `CAKE-LP ${crucible[farm!]?.symbol}-BNB` : crucible[farm!]?.symbol}
                  </FTypo>
                </FTypo>
              </FGridItem>
              <FGridItem size={[6, 6, 6]}>
                <FItem align="right" className="justify-content-end">
                  <div className="flex-center-aligned-center">
                    <img
                      className="cursor-pointer"
                      src={activeAPRIndex === 0 ? IconInactiveLeft : IconActiveLeft}
                      onClick={() => { activeAPRIndex !== 0 && setActiveAPRIndex(activeAPRIndex - 1) }}
                      style={{ height: 9, width: 10, marginRight: 22 }}
                    />
                    <div className="custom-width-117">
                      <p className="medium-text-400 text-center">{aprData[activeAPRIndex]?.label || 'TBD'}</p>
                      <p className="text-35 text-center default-text-color">{farm != 'cTestFrm' ? aprData[activeAPRIndex]?.value :  'TBD'}</p>
                    </div>
                    <img
                      className="cursor-pointer"
                      src={activeAPRIndex < aprData.length - 1 ? IconActiveRight : IconInactiveRight}
                      onClick={() => { activeAPRIndex < aprData.length - 1 && setActiveAPRIndex(activeAPRIndex + 1) }}
                      style={{ height: 9, width: 10, marginLeft: 22 }} />
                  </div>
                </FItem>
              </FGridItem>
            </FGrid>
          </FCard>
        </FCard> */}
        </FContainer>
        <GlobalStyles />
      </ThemeProvider>
    </>
  );
};

export default CrucibleWithdrawFeeCard;
